var map = {
	"./LogoIIL.svg": "2c56",
	"./XVI-logo-anio2-gris-2020.svg": "6e42",
	"./archivo.svg": "81cb",
	"./clip.png": "2925",
	"./clip.svg": "d9c3",
	"./doc.svg": "605b",
	"./icon-01.svg": "6bb0",
	"./icon-03.svg": "d7d6",
	"./icon-04.svg": "8254",
	"./icon-05.svg": "711f",
	"./icon-06.svg": "7f36",
	"./jpg.svg": "155a",
	"./logo-XVI-3er-anio-horizontal.svg": "a6bf",
	"./marca-de-verificacion.svg": "b15c",
	"./mp3.svg": "bc96",
	"./ornato-maya-01.svg": "c46a",
	"./pdf.svg": "3f98",
	"./png.svg": "158b",
	"./subir.svg": "1c95",
	"./svg.svg": "3ec5",
	"./vector_maya_01.svg": "3984",
	"./vector_maya_02.svg": "2913",
	"./verificacion.svg": "f437",
	"./xls.svg": "ca0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";